import React, { useContext, useEffect } from 'react'
import { NavigationContext } from '../context/NavigationContext';
import Button from '../components/Button';
import { PlyrComponent } from 'plyr-react';

const PageTutoriels = () => {

    const { setPage, hideMenu } = useContext(NavigationContext)

    useEffect(() => {
        setPage('tutoriels')
        hideMenu()
        window.scrollTo(0, 1)
    }, [])

    const video1 = {
        type: 'video',
        sources: [
            {
                src: '431747680',
                provider: 'vimeo',
            },
        ]
    }

    const video2 = {
        type: 'video',
        sources: [
            {
                src: '431748542',
                provider: 'vimeo',
            },
        ]
    }

    return (
        <div>
            <h1>Tutoriels</h1>
            <p>Les tutoriels vidéos suivants vous présentent le fonctionnement du site de Pix.</p><br/>
            <h1>Comment utiliser le site de Pix ?</h1>
            <PlyrComponent sources={video1} />
            <p>Dans cette vidéo, nous vous présentons l'utilisation du site Pix (inscription, tests, etc.).</p>
            <br />
            <h1>Comment utiliser le site de présentation de l'UV NF05 ?</h1>
            <PlyrComponent sources={video2} />
            <p>Dans cette vidéo, nous vous présentons le fonctionnement du site sur lequel vous êtes en ce moment.</p>
            <Button align="center" icon="arrow-right" to="?page=presentation">Accueil du site</Button>
        </div>
    );
}

export default PageTutoriels;